export default [
  {
    path: "/home",
    name: "首页展示",
    iconClass: "el-icon-s-home",
    component: () => import("@/components/HomeCustomer"),
    meta: { menuShow: false },
  },
  {
    path: "/devices",
    name: "设备管理",
    iconClass: "el-icon-document",
    component: () => import("@/components/devices/DeviceListCustomer"),
    meta: { menuShow: false },
    children: [
      {
        path: "/devices/:deviceId",
        component: () => import("@/components/show/DeviceInfo"),
        meta: { menuShow: false },
      },
    ],
  },
  {
    path: "/details",
    name: "详细数据",
    iconClass: "el-icon-info",
    component: () => import("@/components/details/ShowA1Customer"),
    meta: { menuShow: false },
    children: [
      {
        path: "/details/:deviceId",
        component: () => import("@/components/show/DeviceInfo"),
        meta: { menuShow: false },
      },
    ],
  },
];
